<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer">
      <div class="appraisal-center fonts marr">
        <div>
          <span>维度：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: resue.examDimensionCode == item.code }"
                v-for="(item, index) in getWDData"
                :key="item.examDimensionId"
                @click="activeEvent(item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag>
          </span>
        </div>
        <div style="margin-top: 20px">
          <span>基准：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, 'active-bg1': resue.benchmarkCode == '' }"
                effect="plain"
                type="danger"
                @click="activeEventJz('all','','')"
            >全部</el-tag
            >
            <el-tag
                :class="{ 'tag-marr': true, 'active-bg1': resue.benchmarkCode == item.code }"
                effect="plain"
                type="danger"
                v-for="(item, index) in getJZData"
                :key="index"
                @click="activeEventJz('',item.code,item.name)"
            >{{ item.name }}</el-tag
            >
          </span>
        </div>
        <div style="margin-top: 20px">
          <el-button v-if="resue.benchmarkCode" type="success" size="small" @click="handleClick('add')"
          >添加结果<i class="el-icon-plus"></i
          ></el-button>
          <span class="subject"
          >共 <i>{{ tagIndex == 0 ? detalisObj.questions : emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
              tagIndex == 0 ? detalisObj.maxScore : emptyShow(getWDData[tagIndex]).maxScore
            }}</i
          >分
          </span>
        </div>
        <div style="margin-top: 20px">
          <div class="public-table-data">
            <el-table
                ref="multipleTable"
                size="medium"
                :data="getWdResulData"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="minScore"
                  label="最小值"
                  width="120"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  prop="maxScore"
                  label="最大值"
                  width="120"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  prop="title"
                  label="标题"
                  width="200"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html="scope.row.title"></div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="content"
                  label="内容"
                  min-width="200"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html="scope.row.content"></div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="descr"
                  label="解析"
                  min-width="400"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html=" $options.filters.ellipsis(scope.row.descr) "
                       style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="suggest"
                  label="建议"
                  min-width="400"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html=" $options.filters.ellipsis(scope.row.suggest) "
                       style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="suggest"
                  label="练习"
                  min-width="400"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-html=" $options.filters.ellipsis(scope.row.guideSuggest) "
                       style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden;"></div>
                </template>
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center"
                  fixed="right"
                  min-width="240"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="handleClick('edit', scope.row)"
                      type="primary"
                      plain
                  >编辑
                  </el-button
                  >
                  <el-button
                      v-if="scope.$index<=4 && detalisObj.examId=='LHXG'"
                      size="mini"
                      @click="conditionClick(scope.row)"
                      type="success"
                      plain
                  >条件
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleDelete(scope.row)"
                      type="danger"
                      plain
                      v-if="numType"
                  >删除
                  </el-button
                  >
                  <el-button
                      v-else
                      size="mini"
                      @click="operationShowTime"
                      type="danger"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <div style="display:flex;">
            <el-form-item label="维度">
              <div>{{ resue.examDimensionName }}</div>
            </el-form-item>
            <el-form-item label="基准">
              <div>{{ resue.benchmarkName }}</div>
            </el-form-item>
          </div>
          <el-form-item label="分值" prop="minScore">
            <el-input
                placeholder="请填最低分值"
                v-model="params.minScore"
                style="width: 262px"
            ></el-input>
            -
            <el-input
                placeholder="请填最高分值"
                v-model="params.maxScore"
                style="width: 262px"
            ></el-input>
          </el-form-item>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请输入名称"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="动物图片" prop="beatVal" v-if="detalisObj.examId=='LHXG'">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span class="slideshow" v-for="(imgUrl, index) in srcList"
                      :key="index">
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="!params.icon"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <quill-editor
                ref="editorComp"
                class="editor"
                v-model="params.title"
                :options="editorOption"
                clearable
            >
            </quill-editor>
          </el-form-item>
          <el-form-item label="欲求说明" prop="content">
            <quill-editor
                ref="editorComp"
                class="editor"
                v-model="params.content"
                :options="editorOption"
                clearable
            >
            </quill-editor>
          </el-form-item>
          <el-form-item label="产生原因" prop="descr">
            <quill-editor
                ref="editorComp"
                class="editor"
                v-model="params.descr"
                :options="editorOption"
                clearable
            >
            </quill-editor>
          </el-form-item>
          <el-form-item label="潜在影响" prop="suggest">
            <quill-editor
                ref="editorComp"
                class="editor"
                v-model="params.suggest"
                :options="editorOption"
                clearable
            >
            </quill-editor>
          </el-form-item>

          <el-form-item label="专业建议" prop="suggest">
            <quill-editor
                ref="editorComp"
                class="editor"
                v-model="params.guideSuggest"
                :options="editorOption"
                clearable
            >
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <operation-confirmation  @closeOperation="publicMethios" :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>

import {isEmpty, emptyShow} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";
import OperationConfirmation from "../../../components/OperationConfirmation";

export default {

  filters: {
    //日期过滤
    // formatDate(time) {
    //   if (time) {
    //     let date = new Date(time);
    //     return formatDate(date, 'yyyy-MM-dd hh:ss:mm');
    //   }
    // },
    //当渲染的文字超出30字后显示省略号
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 60) {
        return value.slice(0, 60) + "...";
      }
      return value;
    }
  },


  data() {
    return {
      //灵魂条件
      isMoer: true,
      srcList: [],
      conditionDialogVisible: false,
      conditionWDData: [],
      conditionInfo: {},
      listCondition: [],
      //之前的代码
      emptyShow, isEmpty,
      detalisObj: {},
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      resue: {
        benchmarkName:"",
        examDimensionName:'',
        examDimensionCode:'',
        benchmarkCode:''
      },
      loading: false,
      dialogVisible: false,
      params: {
        icon:'',
      },
      clickType: "",
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [{header: 1}, {header: 2}], // custom button values
              [{list: "ordered"}, {list: "bullet"}],
              [{script: "sub"}, {script: "super"}], // superscript/subscript
              [{indent: "-1"}, {indent: "+1"}], // outdent/indent
              [{direction: "rtl"}], // text direction

              // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              // [{ header: [1, 2, 3, 4, 5, 6, false] }],

              // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              // [{ font: [] }],
              [{align: []}],
              ["image"],   //   ["link", "image", "video"],
              ["clean"], // remove formatting button
            ],

            handlers: {
              shadeBox: null,
              insertMetric: function () {
                //方法体
                alert(1);
              },
            },
          },
        },
      },
      rules: {
        minScore: [
          {
            required: true,
            message: "请填写正确的分值",
            trigger: "change",
          },
        ],
        // beatVal: [
        //   {
        //     required: true,
        //     message: "请填写击败率",
        //     trigger: "change",
        //   },
        // ],
        // title: [
        //   {
        //     required: true,
        //     message: "请填写标题",
        //     trigger: "change",
        //   },
        // ],
        // content: [
        //   {
        //     required: true,
        //     message: "请填写入内容",
        //     trigger: "change",
        //   },
        // ],
        // descr: [
        //   {
        //     required: true,
        //     message: "请填写解析",
        //     trigger: "change",
        //   },
        // ],
        // suggest: [
        //   {
        //     required: true,
        //     message: "请填写建议",
        //     trigger: "change",
        //   },
        // ],
      },
      operationVisible:false,
      numType:false,
      getJZData:[]
    };
  },
  components: {
    OperationConfirmation
  },
  computed:{
    conditionKey(){
      let arr = []
      if(this.detalisObj.examId=='LHXG'){
        if(this.conditionWDData.length){
          this.conditionWDData.map(item=>{
            let obj_txt = item.code + '-' + item.checkRadio
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    },
    conditionName(){
      let arr = []
      if(this.detalisObj.examId=='LHXG'){
        if(this.conditionWDData.length){
          this.conditionWDData.map(item=>{
            let obj_txt = item.name + (item.checkRadio==1?'(高)':'(低)')
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    }
  },

  created() {
    this.getAppraisalData();
    this.getWDList();
  },
  methods: {
    //清楚缓存数据，重启密码验证
    clearStore(){
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e){
      this.operationVisible = false
      if(e=='open'){
        this.numType = true
        setTimeout(()=>{
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        },1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e){
      this.operationVisible = true
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },

    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );

      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
      this.isMoer = false;
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getWDData = resData.data
      }
      if(this.getWDData.length){
        this.resue.examDimensionName = resData.data[0].name
        this.resue.examDimensionCode = resData.data[0].code
        // 获取第一个维度对应的基准内容
        this.resue.examDimensionCode = resData.data[0].code
        this.getJZList(resData.data[0].code)
      }
    },
    /**
     * 获取基准列表
     */
    async getJZList(code) {
      this.getJZData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/datum/list`, {
        params: {
          examId: this.$route.query.examId,
          examDimensionCode: code,
        },
      });

      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) this.getJZData = resData.data;
      if(this.resue.benchmarkCode){
        this.getWdResultList(this.resue.examDimensionCode,this.resue.benchmarkCode)
      }else {
        this.getWdResultList(this.resue.examDimensionCode)
      }
    },
    /**
     * 获取测评维度j结果列表
     */
    async getWdResultList(examDimensionCode,examDatumCode) {
      this.loading = true;
      let temp = {examId: this.$route.query.examId,}

      if (emptyShow(examDimensionCode)) {
        temp.examDimensionCode = examDimensionCode
      }
      if (emptyShow(examDatumCode)) {
        temp.examDatumCode = examDatumCode
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (emptyShow(resData.data)) {
        this.getWdResulData = resData.data;
      } else {
        this.getWdResulData = [];
      }
    },
    /**
     * 点击维度
     */
    activeEvent(code,name) {
      this.resue.examDimensionName = name
      this.resue.examDimensionCode = code;
      this.resue.benchmarkCode = ''
      this.getJZList(code)
    },
    // 点击基准
    activeEventJz(case_tab,code,name){
      this.resue.benchmarkName = name
      this.resue.benchmarkCode = code
      if(case_tab=='all'){
        this.getWdResultList(this.resue.examDimensionCode)
      }else {

        this.getWdResultList(this.resue.examDimensionCode,this.resue.benchmarkCode)
      }
    },

    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "add") {
        this.params = {}
        this.srcList = []
      }
      if (type == "edit") {
        const {data: resData} = await this.$get(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        this.params = resData.data;
        this.srcList = []
        if(resData.data.icon){
          this.srcList.push(resData.data.icon)
        }
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if(this.params.minScore>this.params.maxScore){
          this.$message.error('最小分必须大于最大分')
          return;
        }
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            this.params.examDimensionCode = this.resue.examDimensionCode;
            this.params.examDatumCode = this.resue.benchmarkCode;
            this.params.examId = this.$route.query.examId;
            const {data: resData} = await this.$post(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.getWdResultList(this.resue.examDimensionCode,this.resue.benchmarkCode)

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.getWdResultList(this.resue.examDimensionCode,this.resue.benchmarkCode)

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList(this.resue.examDimensionCode,this.resue.benchmarkCode)
      });
      this.clearStore()
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.public-dialog-form_tans {
  .title_dun_dime {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .dimension_box {
    display: flex;

    .dimension_box_lis {
      .dimension_content_list {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .dimension_title_info {
          width: 80px;
          text-align: right;
          margin-right: 10px;
        }
      }

      .button_bottom {
        margin-top: 20px;
        margin-left: 80px;
      }
    }
  }
}
</style>